import { hasValue } from '@core/utils/equality';

import { ToastAlertVariants, type ToastWithoutID } from '../ToastContext';

export const createToastMessage = ({ type, subjectName }: ToastWithoutID): string => {
  const subjectMessageVariants: Record<ToastAlertVariants, string> = {
    [ToastAlertVariants.error]: `Failed to save the ${subjectName}`,
    [ToastAlertVariants.success]: `Saved the ${subjectName} successfully`,
    [ToastAlertVariants.info]: '',
  };

  const defaultMessageVariants: Record<ToastAlertVariants, string> = {
    [ToastAlertVariants.error]: 'The requested operation failed',
    [ToastAlertVariants.success]: 'The requested operation was successful',
    [ToastAlertVariants.info]: '',
  };

  return hasValue(subjectName) ? subjectMessageVariants[type] : defaultMessageVariants[type];
};
